import * as XLSX from 'xlsx';
import {AfterViewChecked, Component, ViewChild} from '@angular/core';
import {LoadingService} from '../../../services/loading.service';
import {MatDialogRef} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/typings/stepper';
import {SalePointPlirotisSecondStepComponent} from './sale-point-plirotis-second-step/sale-point-plirotis-second-step.component';
import {StepperService} from '../../../layout/services/stepper.service';

@Component({
  selector: 'app-upload-sale-point-plirotis',
  templateUrl: './upload-sale-point-plirotis-dialog.component.html'
})
export class UploadSalePointPlirotisDialogComponent implements AfterViewChecked {
  @ViewChild('secondStep', {static: true}) secondStep: SalePointPlirotisSecondStepComponent;
  @ViewChild('stepper', {static: true}) stepper: MatStepper;

  public spPlirotisVatNumbers: any[];
  public disableButton: boolean;
  public file: any;

  constructor(private loadingService: LoadingService,
              private matDialogRef: MatDialogRef<UploadSalePointPlirotisDialogComponent>,
              public stepperService: StepperService) {
    this.disableButton = true;
  }

  public ngAfterViewChecked() {
    if (this.stepper) {
      let status;
      switch (this.stepper.selectedIndex) {
        case 0:
          status = this.file === undefined;
          break;
        case 1:
          status = false;
          break;
      }
      if (status !== this.disableButton) {
        setTimeout(() => {
          this.disableButton = status;
        }, 0);
      }
    }
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public async goToNextStep(): Promise<any> {
    if (this.stepper.selectedIndex === 0) {
      this.loadingService.show();
      setTimeout(async () => {
        const promise = new Promise((resolve) => {
          const reader: FileReader = new FileReader();
          reader.onload = (file: any) => {
            const fileName: string = file.target.result;
            const workBook: XLSX.WorkBook = XLSX.read(fileName, {
              dateNF: 'YYYY-MM-DD',
              type: 'binary'
            });
            const workSheetName: string = workBook.SheetNames[0];
            const workSheet: XLSX.WorkSheet = workBook.Sheets[workSheetName];
            const spPlirotisVatNumber: any[] = XLSX.utils.sheet_to_json(workSheet, {
              header: 1,
              raw: false
            });
            spPlirotisVatNumber.shift();
            this.spPlirotisVatNumbers = [];
            for (const row of spPlirotisVatNumber) {
              let model;
              model = {
                  plirotis_code: row[Object.keys(row)[0]],
                  plirotis_name: row[Object.keys(row)[1]],
                  vat_number: row[Object.keys(row)[2]]
                };
              this.spPlirotisVatNumbers.push(model);
            }
            resolve({});
          };
          reader.readAsBinaryString(this.file.file);
        });
        await promise;
        this.loadingService.hide();
        // @ts-ignore
        this.stepperService.goToNextStep(this.stepper);
      }, 500);
    } else {
      await this.secondStep.submitProcess();
      this.matDialogRef.close('success');
    }
  }
}
